import { defineComponent as _defineComponent } from 'vue';
import { computed, defineComponent, toRefs, useSlots } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyList',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    desktopImage: {
      type: String,
      default: ''
    },
    tabletImage: {
      type: String,
      default: ''
    },
    mobileImage: {
      type: String,
      default: ''
    },
    additionalTitle: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'EmptyList'
    });
    var $slots = useSlots();
    var _toRefs = toRefs(useScreenPlugin()),
      isMobile = _toRefs.isMobile,
      isTablet = _toRefs.isTablet;
    var classes = computed(function () {
      var imageUrl = props.desktopImage;
      if (isMobile.value && props.mobileImage) {
        imageUrl = props.mobileImage;
      }
      if (isTablet.value && props.tabletImage) {
        imageUrl = props.tabletImage;
      }
      return {
        '--url-img': "url(".concat(imageUrl, ")")
      };
    });
    return {
      __sfc: true,
      props: props,
      $slots: $slots,
      isMobile: isMobile,
      isTablet: isTablet,
      classes: classes
    };
  }
});